const ITEMS = [
  "HIPAA COMPLIANT",
  "OSHA 29 CFR 1910.1030",
  "TWIC VERIFIED DRIVERS",
  "GDP CERTIFIED",
  "BLOODBORNE PATHOGEN PROTOCOLS",
  "STAT SPECIMENS",
  "DOT HAZMAT TRANSPORTATION",
  "ASHBURN HQ · DMV REGION",
  "24/7/365 LIVE DISPATCH",
];

export const Marquee = () => (
  <section data-testid="compliance-marquee" className="bg-[#0047FF] py-4 overflow-hidden border-y border-blue-700/40">
    <div className="flex w-max whitespace-nowrap animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {ITEMS.map((t) => (
            <span key={`${dup}-${t}`} className="flex items-center">
              <span className="mx-7 font-mono text-xs font-semibold tracking-[0.28em] text-white">{t}</span>
              <span className="text-white/40 font-mono text-xs">//</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
